export function calcLineTotal(price, discount) {
  const p = Math.max(0, Number(price) || 0);
  const d = Math.min(100, Math.max(0, Number(discount) || 0));
  return p * (1 - d / 100);
}

export function newPricedTask(title = '') {
  return {
    id: `task-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    title,
    description: '',
    price: '',
    discount: '0',
  };
}

export function emptyServiceQuote(price = 0) {
  return {
    linePricingMode: 'service',
    price: price ? String(price) : '',
    discount: '0',
    tasks: [newPricedTask('')],
  };
}

export function quoteTotal(quote, fallbackPrice = 0) {
  if (!quote) return Number(fallbackPrice) || 0;
  if (quote.linePricingMode === 'task') {
    return (quote.tasks || []).reduce(
      (sum, task) => sum + calcLineTotal(task.price, task.discount),
      0,
    );
  }
  return calcLineTotal(quote.price ?? fallbackPrice, quote.discount);
}

export function toServiceLinesPayload(selectedIds, quotes, catalog, frequency) {
  const cadence = String(frequency || '').trim();
  return selectedIds.map((id) => {
    const q = quotes[id] || emptyServiceQuote();
    const name =
      catalog.find((row) => row.id === id)?.service ||
      catalog.find((row) => row.id === id)?.name ||
      '';
    const tasks = (q.tasks || [])
      .map((task) => ({
        // Pass through scope, groupName, instructions etc. untouched.
        ...task,
        title: String(task.title || '').trim(),
        description: String(task.description || '').trim(),
        price: Number(task.price) || 0,
        discount: Number(task.discount) || 0,
        total: calcLineTotal(task.price, task.discount),
      }))
      .filter((task) => task.title);
    return {
      catalogServiceId: id,
      name,
      linePricingMode: q.linePricingMode === 'task' ? 'task' : 'service',
      price: Number(q.price) || 0,
      discount: Number(q.discount) || 0,
      total: quoteTotal(q),
      tasks,
      ...(cadence ? { frequency: cadence } : {}),
    };
  });
}
